import type { GridColDef } from "@mui/x-data-grid-premium";
import GridTextHoverLink from "@entrilia/shared/components/grid/GridTextHoverLink";
import { convertISODateTime } from "@entrilia/shared/utilities/dateUtils";
import { nameof } from "@entrilia/shared/utilities/typeHelper";
import type { WorkbookFilter, WorkbookReport, WorkbookTemplate } from "../../../../api/types/workbookRuns.types";
import WorkbookTemplatesGidActionCell from "./WorkbookTemplatesGidActionCell";

interface Params {
  getTemplatePath: (templateId: string) => string;
  onNewRun: (templateId: string) => void;
  onDeleteTemplates: (ids: string[]) => void;
}

export const getColumnDefinitions = ({
  getTemplatePath,
  onNewRun,
  onDeleteTemplates,
}: Params): GridColDef<WorkbookTemplate>[] => [
  {
    field: nameof<WorkbookTemplate>("name"),
    headerName: "Name",
    flex: 1,
    minWidth: 160,
    renderCell: ({ row }) => <GridTextHoverLink to={getTemplatePath(row.id)} text={row.name} />,
  },
  {
    field: nameof<WorkbookTemplate>("reportsSettings"),
    headerName: "Reports",
    width: 80,
    valueFormatter: (value: WorkbookReport[]) => value.length || "-",
    sortable: false,
  },
  {
    field: nameof<WorkbookTemplate>("workbookFilters"),
    headerName: "Workbook Filters",
    width: 140,
    valueFormatter: (value: WorkbookFilter[]) => value.length || "-",
    sortable: false,
  },
  {
    field: nameof<WorkbookTemplate>("createdBy"),
    headerName: "Created by",
    flex: 1,
    minWidth: 140,
  },
  {
    field: nameof<WorkbookTemplate>("createdAt"),
    headerName: "Created at",
    minWidth: 140,
    flex: 1,
    valueFormatter: (value) => convertISODateTime(value),
  },
  {
    field: "actions",
    headerName: "Actions",
    sortable: false,
    width: 176,
    align: "right",
    headerAlign: "right",
    cellClassName: "grid-row-actions",
    renderCell: ({ row }) => (
      <WorkbookTemplatesGidActionCell onNewRun={() => onNewRun(row.id)} onDelete={() => onDeleteTemplates([row.id])} />
    ),
  },
];
